import PrebuiltBet from './_prebuilt-bet.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'

export default {
  name: 'PrebuiltAcca',
  values: {
    view: {
      configSet: PrebuiltBet,
      configValues: {},
    },
    headerContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    headerTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          flexWrap: 'wrap',
        },
      },
    },
    headerText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    marketName: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
